import React from "react";
import { useHistory } from "react-router-dom";
import { useAuthState } from "./";
import PageNotFound from "../PageNotFound";
import Container from "../../components/Container";
import Layout from "../../components/Layout";

const requiresAuth = (
  Component,
  roles = ["Global Admin", "Organization Admin", "Data Steward", "Read-Only"]
) => props => {
  const { isAuthenticated, user } = useAuthState();
  if (isAuthenticated) {
    const isAuthorized = roles.includes(user.role);
    if (isAuthorized) {
      return <Component {...props} />;
    }
    return (
      <Layout>
        <Container>
          <PageNotFound />
        </Container>
      </Layout>
    );
  }

  const history = useHistory();
  history.push("/login");

  return null;
};

export default requiresAuth;
